export default {
  subTextColor: Styles.color.grey.one,
  progressFillColor: Styles.color.primary,
  freeDeliveryTitleColor: Styles.color.primary,
};
